<template>
  <div class="container-delete">
    <div class="img-info">
      <div class="header">
        <div class="title-delete">Confirm invoice deletion</div>
        <div  class="close-button" @click="close">x</div>
      </div>
      <div class="info">
        <div><span>Company name: </span>{{invoice.company_name}}</div>
        <div><span>Invoice: </span>{{invoice.invoice_number}}</div>
        <div><span>Amount: </span>{{formatMoney(invoice.amount)}}</div>
      </div>
      <div class="buttons">
        <button
          :disabled="buttons"
          @click="close()"
          class="cancel"
          :class="{ grey: buttons }">
          Cancel
        </button>
        <button
          :disabled="buttons"
          @click="deleteConfirm()"
          class="confirm"
          :class="{ grey: buttons }">
          Confirm
        </button>
      </div>
      <template v-if="response>0">
        <div class="response">Successfully deleted</div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'modal-wait',
  data() {
    return {
      response: '',
      confirmed: false,
      buttons: false,
    };
  },
  props: {
    invoice: Object,
  },
  methods: {
    close() {
      this.$emit('close', false);
    },
    async deleteConfirm() {
      try {
        this.buttons = true;
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        };
        const { data: response } = await this.$http.post('/v1/transactions/delete', { id: this.invoice.id }, { headers });
        this.response = response;
        setTimeout(() => {
          this.$store.commit('UPDATE_CONFIRMED', true);
          this.close();
        }, 1000);
      } catch (error) {
        console.erro(error);
      }
    },
    formatMoney(value) {
      return value.toLocaleString('en-CA', { style: 'currency', currency: 'USD' });
    },
  },
};
</script>
<style lang="scss">
.container-delete {
  position: fixed;
  display: flex;
  align-items: center;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(48, 48, 48, 0.5);
  .img-info {
    margin: 0 auto;
    background-color: $white;
    width: 44.2vw;
    height: auto;
    border-radius: 10px;
    @media (max-width: 960px) {
      width: 100%;
    }
    span {
      font-weight: 500;
      font-size: 24px;
      letter-spacing: 0.274837px;
      color: $black;
    }
    .header {
      background-color: rgba(22, 32, 86, 0.2);
      display: flex;
      padding:  5px 15px!important;
      justify-content: space-between;
      align-items: center;
      border-radius: 10px 10px 0 0;
      font-weight: bold;
      .close-button {
        cursor: pointer;
        font-size: 24px;
      }
    }
    .info {
      text-align: left;
      padding: 15px;
      font-weight: 500;
      span {
      font-size: 18px;
      }
    }
    .buttons {
      display: flex;
      justify-content: space-between;
      padding: 0 15px;
      margin-bottom: 30px;
      button {
        padding: 8px 25px;
        border-radius: 4px;
        color: $white;
        font-weight: bold;
        outline: none;
        transition: .2s;
        &.cancel {
          background-color: red;
        }
        &.confirm {
          background-color: green;
        }
        &:hover {
          opacity: .7;
        }
        &.grey {
          background-color: #d4d4d4!important;
        }
      }
    }
  }
}
.response {
  background-color: $backgroundPayed;
  padding: 10px;
  font-weight: 500;
  color: $payed;
}
</style>
